import {
  WISH_LIST_FETCH_SUCCESS,
  WISH_LIST_FETCH_RESET,
} from "../actions/types";

const INIT_STATE = {
  wishlist: {},
  wishlists: [],
};

export default (state = INIT_STATE, action = {}) => {
  switch (action.type) {
    case WISH_LIST_FETCH_SUCCESS: {
      return {
        ...state,
        wishlist: action.payload,
      };
    }
    case WISH_LIST_FETCH_RESET: {
      return {
        ...state,
        wishlist: {},
      };
    }
    default:
      return state;
  }
};
